import Section from "./Section";

const Footer = () => {

    return (<footer></footer>);
    // return (
    //     <footer>
    //         <Section extraClasses="with-overflow">
    //             <div className="footer__contact">
    //                 <h4>Get in Touch</h4>
    //                 <ul>
    //                     <li><a href="tel:(877)426-0930">(877) 426.0930</a></li>
    //                     <li><a href="mailto:info@salubrishealth.com">info@salubrishealth.com</a></li>
    //                 </ul>
    //                 <div className="footer__social">
    //                     <h4>Connect</h4>
    //                     <ul>
    //                         <li><a href="https://www.facebook.com/pages/Salubris/336245216501859" target="_blank" rel="noreferrer"><img src="https://www.salubrishealth.com/images/facebook.svg" alt="Visit our Facebook Page" /></a></li>
    //                     </ul>
    //                 </div>
    //                 <ul className="footer__legal dt">
    //                     <li><a href="https://www.salubrishealth.com/terms">Terms and Conditions</a></li>
    //                     <li><a href="https://www.salubrishealth.com/privacy-policy">Privacy Policy</a></li>
    //                 </ul>
    //             </div>
    //             <div className="footer__hub">
    //                 <h4>Provider Portal</h4>
    //                 <ul>
    //                     <li><a href="https://app.sal.health/" target="_blank" rel="noreferrer"><img src="https://www.salubrishealth.com/images/health-hub.svg" alt="Login to our provider portal" /></a></li>
    //                 </ul>
    //             </div>
    //             <ul className="footer__legal mb">
    //             <li><a href="https://www.salubrishealth.com/terms">Terms and Conditions</a></li>
    //             <li><a href="https://www.salubrishealth.com/privacy-policy">Privacy Policy</a></li>
    //             </ul>
    //         </Section>
    //     </footer>
    // );
}

export default Footer;